import React from "react";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";

const SearchInput = ({ freeText, onTextChange, intl }) => (
  <Input
    prefix={<SearchOutlined style={{ padding: "0 5px", opacity: 0.4 }} />}
    placeholder={intl.formatMessage({
      id: `app.settings.system_tables.freeSearch`,
    })}
    value={freeText}
    onChange={onTextChange}
    style={{ width: 300, borderColor: "#4d4d4d" }}
    size="large"
    allowClear
    bordered
  />
);

export default SearchInput;
